import { nils } from "../../utils/utils.jsx";

const cdn = "https://cdn.dnaracing.run";

const skin_baseurl_map = {
  bike: `${cdn}/fbike-skins/`,
  car: `${cdn}/car-skins/`,
  horse: `${cdn}/horse-skins/`,
  new_bike: `${cdn}/new-3d-skins/bike/`,
  new_car: `${cdn}/new-3d-skins/car/`,
};

export const gets_skinurl = (skin, rvmode, is_new) => {
  if (nils(skin)) return null;
  let _rvmode = is_new ? `new_${rvmode}` : rvmode;
  const baseURL = skin_baseurl_map[_rvmode];
  const formattedSkin = encodeURIComponent(skin);
  const newImageURL = `${baseURL}${formattedSkin}/${formattedSkin}.jpg`;
  return newImageURL;
};

// Rarity color mapping - editable hex values
export const rarity_colors = {
  common: "#9CA3AF",      // Gray
  rare: "#3B82F6",        // Blue
  epic: "#A855F7",        // Purple
  legendary: "#F59E0B",   // Orange
  ultimate: "#EF4444",    // Red
  exclusive: "#10B981",   // Emerald
};

// Generate primary color from skin title
export const get_primary_color = (title) => {
  if (!title) return "#6B7280";

  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = title.charCodeAt(i) + ((hash << 5) - hash);
  }

  const hue = Math.abs(hash) % 360;
  const saturation = 60 + (Math.abs(hash) % 30); // 60-90%
  const lightness = 45 + (Math.abs(hash) % 20);  // 45-65%

  // Convert HSL to hex
  const hslToHex = (h, s, l) => {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color).toString(16).padStart(2, '0');
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  };

  return hslToHex(hue, saturation, lightness);
};

// Generate accent color from skin title
export const get_accent_color = (title) => {
  if (!title) return "#9CA3AF";

  let hash = 0;
  for (let i = 0; i < title.length; i++) {
    hash = title.charCodeAt(i) + ((hash << 7) - hash);
  }

  const hue = (Math.abs(hash) + 120) % 360; // Offset by 120 degrees
  const saturation = 70 + (Math.abs(hash) % 25); // 70-95%
  const lightness = 35 + (Math.abs(hash) % 25);  // 35-60%

  // Convert HSL to hex
  const hslToHex = (h, s, l) => {
    l /= 100;
    const a = s * Math.min(l, 1 - l) / 100;
    const f = n => {
      const k = (n + h / 30) % 12;
      const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
      return Math.round(255 * color).toString(16).padStart(2, '0');
    };
    return `#${f(0)}${f(8)}${f(4)}`;
  };

  return hslToHex(hue, saturation, lightness);
};